module.exports = __webpack_public_path__ + "static/media/process-growth.fae03583.svg";